import React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
// import StyledIcon from 'components/acommon/StyledIcon';
import Button from 'components/Button';
// import {NavLink} from 'react-router-dom';
import {smallClockIcon, smallGuestIcon} from 'components/acommon/StyledIcon';
// import {useTranslation} from 'react-i18next';
// import {isEmpty, get} from 'lodash';
// import api from 'api';

const ViewDetailsButton = styled(Button)`
  display: none;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 350px;
  max-height: 540px;
  /* border: 1px solid red; */
  font-family: 'Poppins', sans-serif;

  &:hover {
    cursor: pointer;
    box-shadow: 0px 64px 64px #0f0f0f14;
    border-radius: 0 0 25px 25px;
  }

  &:hover ${ViewDetailsButton} {
    display: block;
  }
`;

export const Image = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 100%;
  max-height: 300px;
  width: 350px;
  height: 300px;

  .saleBadge {
    position: absolute;
    left: 15px;
    top: 15px;
    width: fit-content;
    background-color: #23262f;
    border-radius: 25px;
    padding: 5px 12px;
    color: #fcfcfd;
    font-size: 12px;
    font-weight: 700;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  .hours {
    display: flex;
    align-items: center;
    color: #777e91;
    font-size: 12px;
    font-weight: 400;

    :before {
      display: flex;
      align-items: center;
      line-height: 1;
      content: url(${smallClockIcon});
      margin-right: 5px;
    }
  }
  .people {
    display: flex;
    align-items: center;
    line-height: 1;
    color: #777e91;
    font-size: 12px;
    font-weight: 400;
    margin-left: 15px;

    :before {
      display: flex;
      align-items: center;
      content: url(${smallGuestIcon});
      margin-right: 5px;
    }
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  width: 100%;
  border: 1px solid #e6e8ec;
  border-top-style: none;
  border-radius: 0 0 25px 25px;

  .name {
    color: #23262f;
    font-size: 16px;
    font-weight: 500;
  }
  .price {
    color: #32d7be;
    font-size: 16px;
    font-weight: 500;
  }

  .desc {
    color: #777e90;
    font-size: 12px;
    font-weight: 400;
    padding: 20px 0;
  }
  .total {
    color: #23262f;
    font-size: 12px;
    font-weight: 600;
  }
`;

export const PriceLabel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid #32d7be;
  border-radius: 3px;
  min-width: 50px;
  min-height: 50px;

  .oldPriceLabel {
    color: #b1b5c4;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 13px;
    text-decoration: line-through;
  }
  .newPriceLabel {
    color: #32d7be;
    font-family: 'Poppins', sans-serif;
    font-weight: bold;
    font-size: 14px;
  }
`;

type CardTypes = {
  photo: string;
  name: string;
  desc: string;
  hours: number;
  people: number;
  price: number;
  id?: number;
};

function Recommendations({photo, name, desc, hours, people, price, id}: CardTypes) {
  const {t} = useTranslation();
  // const {t} = useTranslation();
  // const handleDownloadButton = React.useCallback(async () => {
  //   console.log('reservationId', reservationId);
  //   if (!reservationId) {
  //     return;
  //   }

  //   const {data, error} = await api.documents.getContracts(
  //     `housing_sample_id=${housingId}`,
  //   );
  //   const contract = get(data, '0.file');

  //   if (contract) {
  //     window.open(contract, '__blank');
  //   }

  //   if (error) {
  //     console.log('error', error);
  //   }
  // }, [housingId, reservationId]);

  const handleButton = () => {
    console.log('click');
  };

  return (
    <Card key={id}>
      <Image
        style={{
          backgroundImage: `url(${photo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="saleBadge">20% {t('off_uppercase')}</div>
        <ViewDetailsButton onClick={handleButton} label={t('view_details')} short />
      </Image>
      <Information style={{padding: '25px'}}>
        <Row style={{justifyContent: 'space-between'}}>
          <div className="name">{name}</div>
          <PriceLabel>
            <div className="oldPriceLabel">{`$${price + 102}`}</div>
            <div className="newPriceLabel">{`$${price}`}</div>
          </PriceLabel>
        </Row>
        <Row style={{borderBottom: '1px solid #E6E8EC', padding: '20px 0'}}>
          <div className="hours">
            {hours} {t('hours')}
          </div>
          <div className="people">{`Up to ${people} people`}</div>
        </Row>
        <div className="desc">{desc}</div>
        <div className="total">$200 {t('total')}</div>
      </Information>
    </Card>
  );
}

export default Recommendations;
